import React from 'react';
import { connect } from 'react-redux';
import * as featureClassesActions from './../../../../../actions/featureClassActions';
import * as productFeaturesActions from '../../../../../actions/productMainEdit/productFeatureActions';
import axios from './../../../../../constants/axios';
import alert from 'alertify.js';


class ProductMainEditFeature extends React.Component {

   componentDidMount() {
      const { productId } = this.props.params;
      this.props.dispatch(featureClassesActions.loadAllFeatureClasses());
      this.props.dispatch(productFeaturesActions.loadProductFeaturesById(productId));
   }

   removeFeatureFromProduct = (itemFeatureId) => {
      axios.delete(`items/productMain/removeProductFeature/${itemFeatureId}`)
         .then((res) => {
            if (res.status === 204) {
               alert.success('Removed Product Feature');
               this.props.dispatch(productFeaturesActions.removeProductFeature({
                  id: itemFeatureId
               }));
            } else {
               alert.error('Unknown error. Call Admin.');
            }
         })
         .catch((res) => {
            if (res.response.status === 422) {
               alert.error(res.response.data);
            }
         });

   };
   addFeatureToProduct = (featureId, featureName, featureClassId, featureClassName) => {
      const { productId } = this.props.params;
      return axios.post(`items/productMain/addProductFeature/${productId}`,
         {
            feature_id: featureId,
            feature_class_id: featureClassId
         })
         .then((res) => {
            if (res.status === 201) {
               alert.success('Product Feature added.');
               this.props.dispatch(productFeaturesActions.addProductFeature({
                  productFeature: {
                     id: res.data.item_feature_id,
                     feature_class_name: featureClassName,
                     feature_name: featureName
                  }
               }));
            }
         })
         .catch((res) => {
            if (res.response.status === 422) {
               alert.error(res.response.data);
            }
         });
   };

   render() {
      const featureClassStyle = {
         height: '500px',
         overflow: 'y-scroll'
      };
      const { featureClasses, productFeatures } = this.props;
      return (
         <div className="row" >
            <div className="col-md-6" >
               <h5>Product Features</h5>
               {productFeatures.map((pFeature) => (
                  <p key={pFeature.id} >
                     <span onClick={() => this.removeFeatureFromProduct(pFeature.id)}
                           className="text-danger" >remove</span>
                     {" "}
                     {pFeature.feature_class_name} :: {pFeature.feature_name}
                  </p>
               ))}
            </div>
            <div className="col-md-6" >
               <h5>Feature List</h5>
               <ul style={featureClassStyle} >
                  {featureClasses.map((fClass) => (
                     <li key={fClass.id} >{fClass.name}
                        {fClass.features ?
                           <ul>
                              {fClass.features.map((feature) => (
                                 <li key={feature.id} >
                                    <span
                                       onClick={() => this.addFeatureToProduct(feature.id, feature.name, fClass.id, fClass.name)}
                                       className="text-success" >add</span>
                                    {" "}
                                    {feature.name}
                                 </li>
                              ))}
                           </ul>
                           :
                           null
                        }
                     </li>
                  ))}
               </ul>
            </div>
         </div>
      );
   }
}

ProductMainEditFeature.propTypes = {
   dispatch: React.PropTypes.func,
   featureClasses: React.PropTypes.array,
   productFeatures: React.PropTypes.array,
   productId: React.PropTypes.number,
   params: React.PropTypes.object
};

function mapStateToProps(state) {
   return {
      featureClasses: state.featureClasses,
      productFeatures: state.productFeatures
   };
}
export default connect(mapStateToProps)(ProductMainEditFeature);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditFeature.js
 **/